import styles from './button-wrapper.module.less';

const ButtonWrapper = ({ className = '', ...props }) => {
    return <div className={[styles.buttonWrapper, className].join(' ')} {...props} />;
};

export default ButtonWrapper;
